import React from 'react';
import { PIPELINE_STAGES, getStageProgress, getStageColor } from './uploadStages';

// Inline list of candidates currently being parsed/matched (above ranked list)
export function ProcessingPipeline({ candidates }) {
  if (!candidates || candidates.length === 0) return null;

  return (
    <div data-testid="processing-pipeline" style={{ marginBottom: '1rem' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.625rem' }}>
        <span className="status-dot status-processing" />
        <span style={{ fontSize: '0.75rem', fontWeight: 600, color: '#F59E0B' }}>
          {candidates.length} resume{candidates.length > 1 ? 's' : ''} processing
        </span>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
        {candidates.map((c) => {
          const stage = PIPELINE_STAGES[c.status] || PIPELINE_STAGES.uploaded;
          const pct = getStageProgress(c.status);
          const color = getStageColor(c.status);
          return (
            <div
              key={c._id}
              data-testid="processing-candidate-card"
              style={{
                display: 'flex', alignItems: 'center', gap: '0.875rem',
                padding: '0.75rem 1rem', borderRadius: 12,
                background: 'hsl(var(--card))',
                border: '1px solid rgba(240, 80, 0, 0.15)',
                animation: 'fadeInUp 0.22s ease-out',
              }}
            >
              <div style={{
                width: 32, height: 32, borderRadius: '50%',
                background: 'linear-gradient(135deg, #0076A3, #00A0E0)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: '0.75rem', fontWeight: 600, color: '#fff', flexShrink: 0
              }}>
                {c.name?.charAt(0)?.toUpperCase()}
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: '0.8125rem', fontWeight: 600, marginBottom: '0.25rem' }}>{c.name}</div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                  <div style={{ flex: 1, height: 4, borderRadius: 2, background: 'rgba(255,255,255,0.06)', overflow: 'hidden' }}>
                    <div style={{
                      height: '100%', borderRadius: 2,
                      background: `linear-gradient(90deg, #0076A3, ${color})`,
                      width: `${pct}%`,
                      transition: 'width 0.6s ease-out',
                    }} />
                  </div>
                  <span style={{ fontSize: '0.6875rem', color, fontFamily: 'JetBrains Mono', fontWeight: 600, minWidth: 28, textAlign: 'right' }}>
                    {pct}%
                  </span>
                </div>
              </div>
              <span style={{ fontSize: '0.6875rem', color: 'hsl(var(--muted-foreground))', whiteSpace: 'nowrap' }}>
                {stage.label}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
